/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

/**
 * The type of an indeterminate value.
 */

/**
 * A constant value indicating that a component's value is indeterminate.
 */
export const AB_INDETERMINATE_VALUE = Symbol("AbIndeterminateValue");
//# sourceMappingURL=AbIndeterminateValue.js.map
